import React, { useEffect, useRef, useState } from 'react';
import { GroupedDataGrid } from '../../data/components/GroupedDataGrid';
import { IPFieldProps } from '../../types/field-props';
import JSGroupedDataGrid from '../types/JSGroupedDataGrid';
import { CForm } from '../types/JSForm';
import { useForceUpdate } from '@ioip/core/lib/hooks/useForceState';

export const UXGroupedDataGrid = (props: IPFieldProps<JSGroupedDataGrid>): JSX.Element => {

    const formRef = useRef<CForm>();
    const [ isLoading, setIsLoading ] = useState(true);
    const forceUpdate = useForceUpdate();

    useEffect(() => {
        formRef.current = props.field.getForm()
        formRef.current.onInvokeRender = () => {
            forceUpdate();
        };
        setIsLoading(false);
    }, [])

    if (isLoading)
        return <></>

    const value = props.field.value as any ?? [];
    const columns = props.field.getColumns();

    console.log('formRef.current', columns);

    return <div style={{ maxHeight: '400px' }}>
        <GroupedDataGrid
            columns={columns}
        />
    </div>

}